const CameraIcon = ({ height = 16, width = 16, style = {} }) => (
  <svg style={{ height, width, ...style }} viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.0381 6.57233H27.7663L26.232 1H9.81734L8.28309 6.57233H4.99276C2.79304 6.57233 1 8.37405 1 10.5844V23.9952C1 26.2055 2.79304 28.0072 4.99276 28.0072H31.0381C33.2378 28.0072 35.0309 26.2055 35.0309 23.9952V10.5844C35.0309 8.37405 33.2378 6.57233 31.0381 6.57233Z"
      stroke="#8E9697"
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
      alt="Camera icon"
    />
    <path
      d="M18.0069 22.3423C21.2941 22.3423 23.959 19.6645 23.959 16.3613C23.959 13.0581 21.2941 10.3804 18.0069 10.3804C14.7196 10.3804 12.0547 13.0581 12.0547 16.3613C12.0547 19.6645 14.7196 22.3423 18.0069 22.3423Z"
      stroke="#8E9697"
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
);

export default CameraIcon;
